import React, {useEffect} from 'react';
import {BrowserRouter, HashRouter, Route, Switch} from 'react-router-dom';
import Helmet from "react-helmet-async";
import './App.css';
import Main from "./Routes/Main";
import QuestionPage from "./Routes/QuestionPage";
import ResultPage from "./Routes/ResultPage";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import styled from "styled-components";
import ReactGA from "react-ga";

function App() {
  return (
          <HashRouter>
            <Route render={({ location }) => {
                return (
                    <Container className="App">
                            <TransitionGroup component={null}>
                                <CSSTransition
                                    timeout={10}
                                    className="page"
                                    key={location.key}
                                    >
                                    <Switch location={location}>
                                        <Route exact path="/" component={Main}/>
                                        <Route path="/test" component={QuestionPage}/>
                                        <Route path="/result/:id" component={ResultPage}/>
                                    </Switch>
                                </CSSTransition>
                            </TransitionGroup>
                    </Container>
                )
            }}/>
          </HashRouter>
  )
}
export default App;
const Container = styled.div`
    background-color: #191a27;
    width: 100%;
`